export default __webpack_public_path__ + "static/media/GfG Game of Source.3b025f20.png";